import i18n from 'i18next'
import { initReactI18next, useTranslation } from 'react-i18next'
import { ko as consultationKo, ja as consultationJa } from '@healingpaper/consultation-web/locale'

import originJa from '../lang/ja.json'
import originKo from '../lang/ko.json'
import originEn from '../lang/en.json'
import originTh from '../lang/th.json'
import originZhHans from '../lang/zh-Hans.json'
import originZhHant from '../lang/zh-Hant.json'

export { i18n, initReactI18next, useTranslation }
export const ja = mergeTranslations(originJa, consultationJa)
export const ko = mergeTranslations(originKo, consultationKo)
export const en = mergeTranslations(originEn, { translation: {} })
export const th = mergeTranslations(originTh, { translation: {} })
export const china = mergeTranslations(originZhHans, { translation: {} })
export const tw = mergeTranslations(originZhHant, { translation: {} })

function mergeTranslations(origin: { translation: Record<string, any> }, ...translationsFile: Record<string, any>[]) {
  if (!translationsFile) {
    return origin
  }
  return {
    translation: translationsFile.reduce((acc, cur) => ({ ...acc, ...cur }), { ...origin.translation }),
  }
}
